import DiscoverNavbar from "components/public/DiscoverNavbar"
import { ReactNode } from "react"
import DiscoverTabs from "components/Discover/DiscoverTabs"
import DiscoverTags from "components/Discover/DiscoverTags"
import useColorStyles from "hooks/useColorStyles"

interface Props {
  className?: string
  showBlogName?: boolean
  children: ReactNode
  showTags?: boolean
}

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ")
}

export default function DiscoverLayout({
  className,
  children,
  showTags,
}: Props) {
  const customStyles = useColorStyles(true)

  return (
    <div className={classNames("bg-white", className ? className : "")}>
      <div className="shadow">
        <DiscoverNavbar />
      </div>
      <div className="max-w-4xl mx-auto mt-8">
        <DiscoverTabs />
      </div>

      {showTags && (
        <div className="overflow-x-auto mx-auto mt-4">
          <DiscoverTags />
        </div>
      )}

      {/* This is needed to ensure all the custom colors (ie, bg-custom-50 on hover) are applied 
          Even though there are no custom colors in the discover page. */}
      <div
        style={{ ...customStyles } as any}
        className="mx-auto max-w-4xl border-t border-gray-200"
      >
        {children}
      </div>
    </div>
  )
}
